import axios from "axios";
import { base_url } from "../api/api";
import { BACKEND_URL } from "../Backend/backend";

/* hex to hsl */
export const convertColorToHsl = function (hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  var r = parseInt(result[1], 16);
  var g = parseInt(result[2], 16);
  var b = parseInt(result[3], 16);

  r /= 255;
  g /= 255;
  b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  s = s * 100;
  s = Math.round(s);
  l = l * 100;
  l = Math.round(l);
  h = Math.round(360 * h);

  return { h, s, l };
};

export const hslToHex = function (h, s, l) {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0"); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};

/*helper function to set the customer's birthday in the database. */
export const updateCustomerBirthday = async function (
  shopDomain,
  customerId,
  day,
  month
) {
  if (customerId && month && day) {
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: { day, month, shopDomain: shopDomain },
    };
    await base_url(`/birthday/${customerId}`, options);
  }
};

/*helper function to generate the fixed amount coupon code when customer
clicks on redeem. */
export const generateDiscountCode = async function (shopDomain, customerId) {
  const res = await base_url(
    `/discount/${customerId}?shopDomain=${shopDomain}`
  );
  const data = res.data;
  localStorage.setItem("discount", data);
  return data;
};

/*helper function to generate the free shipping coupon code when customer
clicks on redeem. */
export const generateFreeShippingCode = async function (
  shopDomain,
  customerId
) {
  const res = await base_url(
    `/shipping/${customerId}?shopDomain=${shopDomain}`
  );
  const data = res.data;
  localStorage.setItem("discount", data);
  return data;
};

/*helper function to generate the percentage off coupon code when customer
clicks on redeem. */
export const generatePercentageCode = async function (shopDomain, customerId) {
  const res = await base_url(
    `/percentage-discount/${customerId}?shopDomain=${shopDomain}`
  );
  const data = res.data;
  // console.log(data);
  localStorage.setItem("discount", data);
  return data;
};

/*helper function to donate charity points when customer
clicks on redeem. */
export const donateCharityPoints = async (
  shopDomain,
  customerId,
  charityName,
  DonationAmt
) => {
  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: { charityName, DonationAmt },
  };
  try {
    await base_url(
      `/charity/donate/${customerId}?shopDomain=${shopDomain}`,
      options
    );
  } catch (error) {
    console.log(error);
  }
};

/*helper function to generate the free product when customer
clicks on redeem. */

export const redeemFreeProduct = async (
  shopDomain,
  customerId,
  id,
  categoryId = false
) => {
  const options = {
    method: "put",
    url: `${BACKEND_URL}/points/redeem/free-product/${customerId}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: { shopDomain, variantId: id, categoryId },
  };

  await axios(options)
    .then((res) => {})
    .catch((err) => {
      console.log(err);
    });
};

/*helper function to give the social points when customer
clicks on redeem. */

export const giveSocialPoints = async (shopDomain, customerId, name) => {
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify({
      shopDomain: shopDomain,
      name: name,
    }),
  };
  await base_url(`/social/points/${customerId}`, options);
};

/*helper function to give the social giftcards when customer
clicks on redeem. */

export const giveSocialGiftcard = async (shopDomain, customerId, name) => {
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify({
      shopDomain: shopDomain,
      name: name,
    }),
  };
  await base_url(`/social/giftcard/${customerId}`, options);
  // console.log("social giftcard redeemed");
};

export const setReferrarCode = async (shopDomain, customerId, referrerCode) => {
  const options = {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      referrerCode,
    },
  };
  await base_url(
    `/referral-reward/${customerId}?shopDomain=${shopDomain}`,
    options
  );
};

/*helper function to generate the tier percent coupon code when customer
clicks on redeem. */
export const generateTierPercentCode = async (
  shopDomain,
  customerId,
  percentageCouponObj
) => {
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify({
      shopDomain,
      percentageCouponObj,
    }),
  };
  const res = await base_url(
    `/redeem/percentage-coupon-tier/${customerId}`,
    options
  );
  const data = res.data;
  return data;
};

/*helper function to generate the tier fixed coupon code when customer
clicks on redeem. */
export const generateTierDiscountCode = async (
  shopDomain,
  customerId,
  fixedCouponObj
) => {
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify({
      shopDomain,
      fixedCouponObj,
    }),
  };
  const res = await base_url(
    `/redeem/fixed-coupon-tier/${customerId}`,
    options
  );
  const data = res.data;
  return data;
};
export const redeemPointsForGiftcard = async (
  shopDomain,
  customerId,
  giftcardAmt
) => {
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify({
      shopDomain,
      customerId,
      giftcardAmt,
    }),
  };
  const res = await base_url(`/redeem/giftcard`, options);
  const data = res.data;
  return data;
};

/**
 * @name - checkTierBenefitsEligibility
 * @description - This function checks if the customer is eligible for the tier benefits
 * @param {Array} vipTiers - The vip tiers array
 * @param {String} customerTier - The customer tier
 * @param {String} compareTier - The tier to compare with
 */
export const checkTierBenefitsEligibility = (
  vipTiers,
  customerTier,
  compareTier
) => {
  if (!Array.isArray(vipTiers)) return true;

  const customerTierIndex = vipTiers.findIndex(
    (tier) => tier?.listName === customerTier
  );
  const compareTierIndex = vipTiers.findIndex(
    (tier) => tier?.listName === compareTier
  );

  // If both tiers are not found
  if (customerTierIndex === -1 && compareTierIndex === -1) return true;

  // If customer tier is higher than or equal to compare tier
  if (customerTierIndex >= compareTierIndex) return true;

  return false;
};
